import {BreadcrumbName} from 'common/src/modules/breadcrumbs/breadcrumbs.enums';
import {SkillName} from 'common/src/modules/shared/copilot/skills/skills.enums';
import generalNavigationTool from 'common/src/modules/shared/copilot/tools/generalNavigationTool/generalNavigationTool';
import skill from 'common/src/modules/shared/copilot/utils/creators/skill';
import {CLStore} from 'common/src/redux/store';
import browserHistoryTool from './tools/browserHistoryTool/browserHistoryTool';

function generalNavigationSkill(store: CLStore) {
  return skill({
    name: SkillName.GeneralNavigation,
    description:
      'Navigates the platform using natural language and provides access to browser navigation history for back/forward navigation',
    whenToUse:
      'Navigating to different pages and routes in the platform, going back to a previously visited page, going forward in history, or checking what pages the user has visited. Handles requests like "take me to", "go back", "go to the previous page", "where was I before", and "navigate to".',
    instructions:
      'Help the user navigate the platform. You can navigate to specific pages using natural language, read the navigation history to see where the user has been, and go back or forward through visited pages. When the user asks to go back, read the history first to confirm where they will be navigated to.',
    tools: [generalNavigationTool(store.getState), browserHistoryTool()],
    applicableBreadcrumbs: [BreadcrumbName.FlightControl],
  });
}

export default generalNavigationSkill;
